import ConversationQueryTraversal from 'owa-service/lib/contract/ConversationQueryTraversal';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';

/**
 * Gets the traversal based on the view filter
 * @param viewFilter The view filter for which to get the traversal
 * @returns a traversal of type ConversationQueryTraversal
 */
export default function getFindConversationTraversal(
    viewFilter: ViewFilter
): ConversationQueryTraversal {
    switch (viewFilter) {
        case 'Hashtag':
        case 'UserCategory':
            return 'Deep'; // A Deep Traversal means to fetch items from the root folder and all the sub folders

        default:
            return undefined; // A null does not work as it sends a value as null to server which does not work
    }
}
